import React, { useState } from 'react';
import { Card, CardBody, TabContent, TabPane } from 'reactstrap';
import { useMutation } from '@apollo/client';
import { toast } from 'react-toastify';
import FSBModal from 'components/common/FSBModal';
import CustomTabs from 'components/CustomTabs';
import Heading from 'components/Heading';
import EditPlans from 'components/EditPlans';
import DeleteConfirmationAlert from 'components/DeleteConfirmationAlert';
import { VENDOR_TYPES } from 'pages/Vendor/constants';
import IndianSubscriptionPlans from './components/IndianSubscriptionPlans';
import ForeignSubscriptionPlans from './components/ForeignSubscriptionPlans';
// import AddEditSubscriptionPlans from './components/AddEditSubscriptionPlans';
import { DELETE_SUBSCRIPTION_PLAN } from './subscriptionPlanGraphQL';

const SubscriptionPlans = () => {
  const [activeTab, setActiveTab] = useState(VENDOR_TYPES.INDIAN);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [subscriptionPlanRow, setSubscriptionPlanRow] = useState({
    row: '',
    refetch: () => {},
  });
  const [deleteRowId, setDeleteRowId] = useState({ id: '', refetch: () => {} });
  const [showDeleteRecord, setDeleteRecord] = useState(false);

  const [deleteSubscriptionPlan] = useMutation(DELETE_SUBSCRIPTION_PLAN, {
    // eslint-disable-next-line no-shadow
    onCompleted: ({ deleteSubscriptionPlan }) => {
      toast.success(deleteSubscriptionPlan?.message);
      deleteRowId?.refetch();
      setDeleteRowId({ id: '', refetch: () => {} });
      setDeleteRecord(!showDeleteRecord);
    },

    onError: ({ graphQLErrors }) => {
      graphQLErrors.map(({ message }) => {
        toast.error(message);
        return message;
      });
    },
  });

  const toggleDeleteRecord = (id, refetch = () => {}) => {
    setDeleteRecord(!showDeleteRecord);
    setDeleteRowId({ id, refetch });
  };

  const onDeleteConfirmation = async () => {
    try {
      await deleteSubscriptionPlan({
        variables: { subscriptionPlanId: deleteRowId?.id },
      });
    } catch (e) {
      //console.error(e);
    }
  };

  const drawerToggle = (value, refetch = () => {}) => {
    setIsDrawerOpen(!isDrawerOpen);
    setSubscriptionPlanRow({ row: value, refetch });
  };
  const toggle = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  const handleClickEdit = (data, refetch = () => {}) => {
    drawerToggle(data, refetch);
  };

  return (
    <div className="staff-page">
      <div className="mb-3 top-head">
        <Heading title="Subscription Plans" />
      </div>
      <DeleteConfirmationAlert
        open={showDeleteRecord}
        title="Delete"
        message="Do you really want to remove this record?"
        cancelButtonLabel="Close"
        addButtonLabel="Delete"
        onConfirm={onDeleteConfirmation}
        onCancel={toggleDeleteRecord}
      />
      {isDrawerOpen && (
        <FSBModal
          title={`${subscriptionPlanRow?.row?.planName} Plan`}
          open={isDrawerOpen}
          toggleAlert={drawerToggle}
          onClose={drawerToggle}
          message=""
          modalClass="right-drawer"
        >
          <EditPlans
            drawerToggle={drawerToggle}
            currentRow={subscriptionPlanRow?.row}
            refetch={subscriptionPlanRow?.refetch}
          />

          {/* <AddEditSubscriptionPlans
            value={subscriptionPlanRow}
            drawerToggle={drawerToggle}
          /> */}
        </FSBModal>
      )}
      <Card className="border-0 card-box page-card-box ">
        <CardBody>
          <CustomTabs
            tabs={[VENDOR_TYPES.INDIAN, VENDOR_TYPES.FOREIGN]}
            selectedTab={activeTab}
            onTabChange={toggle}
            className="mb-2"
          />
          <TabContent activeTab={activeTab}>
            {activeTab === VENDOR_TYPES.INDIAN && (
              <TabPane tabId={VENDOR_TYPES.INDIAN}>
                <IndianSubscriptionPlans
                  handleClickEdit={handleClickEdit}
                  toggleDeleteRecord={toggleDeleteRecord}
                />
              </TabPane>
            )}
            {activeTab === VENDOR_TYPES.FOREIGN && (
              <TabPane tabId={VENDOR_TYPES.FOREIGN}>
                <ForeignSubscriptionPlans
                  handleClickEdit={handleClickEdit}
                  toggleDeleteRecord={toggleDeleteRecord}
                />
              </TabPane>
            )}
          </TabContent>
        </CardBody>
      </Card>
    </div>
  );
};

export default SubscriptionPlans;
